<template>
    <FeaturePageLayout
      :pageTitle="meta.title"
      :pageDescription="meta.description"
    >
      <PageHeaderFeature
        title="SMS marketing that cuts through the noise"
        subtitleText="Reach your audience directly on their phones with SMS campaigns. Transpond enables you to send targeted SMS messages and enhance engagement across multiple channels."
        buttonText="Get started"
        buttonLink="Pricing"
      ></PageHeaderFeature>
  
      <SectionHero
      theme="green"
      image="sms-hero"
      title="Keep customers in the loop with SMS updates"
      :paragraphs="[
        'Want to ensure customers see your messages? Transpond provides a fast and effective way to send transactional SMS to your customers – from appointment reminders to order confirmations. Reach customers wherever they are and increase response rates.',
        'Currently available to UK customers only.',
      ]"
    ></SectionHero>
  
      <SectionTwoColumnRight
        title="Run omnichannel campaigns for maximum engagement"
        content="Your customers don’t live in just one channel, so why market to them as if they do? Expand your reach by integrating SMS with your existing campaigns. Transpond makes it easy to include SMS in your marketing, so you can engage customers on multiple channels and ensure your message reaches them through the most effective method."
        image="channel-campaigns"
      ></SectionTwoColumnRight>
  
      <SectionTwoColumnLeft
      title="Boost conversion rates with direct outreach"
      content="SMS messages have significantly higher open rates than other channels, making them an excellent tool for driving engagement. By speaking directly to your customers, Transpond helps you to automate personalized, time-sensitive messages that encourage your customers to take immediate action, ultimately boosting your conversion rates and strengthening your marketing."
      image="sms-outreach"
    ></SectionTwoColumnLeft>
  
    </FeaturePageLayout>
  </template>
  
  <script>
  import FeaturePageLayout from "@/layouts/FeaturePageLayout.vue";
  import PageHeaderFeature from "@/components/Header/PageHeaderFeature.vue";
  import SectionHero from "@/components/Features/SectionHero.vue";
  import SectionTwoColumnLeft from "@/components/ContentSections/SectionTwoColumnLeft";
  import SectionTwoColumnRight from "@/components/ContentSections/SectionTwoColumnRight";
  
  export default {
    name: "CampaignBuilder",
    components: {
      FeaturePageLayout,
      PageHeaderFeature,
      SectionHero,
      SectionTwoColumnLeft,
      SectionTwoColumnRight,
    },
    data() {
      return {
        meta: {
          title: "SMS Marketing Platform | Transpond",
          description:
            "Send targeted, high-converting SMS messages that reach customers instantly.",
        },
      };
    },
  
    methods: {
      openWindow: function (link, self) {
        window.open(link, self ? "_self" : "_blank");
      },
    },
  };
  </script>
  